<template>
  <div class="rights">
    <div class="rights-dialog">
      <img src="../../assets/images/logo-bg.png"
           draggable="false"
           class="rights-logo" alt="">
      <h1 class="rights-title">PDF转换属于猎豹安全浏览器专属功能</h1>
      <template v-if="isLiebao">
        <h3 v-if="!isLiebao" class="rights-subtitle">
          建议升级到最新版猎豹安全浏览器后使用
        </h3>
        <a href="https://www.liebao.cn"
           target="_blank"
           class="rights-download">
          立即升级
        </a>
      </template>
      <template v-else>
        <h3 v-if="!isLiebao" class="rights-subtitle">
          请使用猎豹安全浏览器打开，享受转换权益，如未安装猎豹安全浏览器，请安装后使用转换权益
        </h3>
        <a href="https://www.liebao.cn"
           target="_blank"
           class="rights-download">
          立即下载
        </a>
      </template>
      <ul class="rights-wrapper">
        <li class="rights-item">
          <img src="../../assets/icon/rights/1.png"
               draggable="false"
               class="rights-item-logo"
               alt="">
          <p class="rights-item-des">PDF 转 Word</p>
        </li>
        <li class="rights-item">
          <img src="../../assets/icon/rights/2.png"
               draggable="false"
               class="rights-item-logo"
               alt="">
          <p class="rights-item-des">PDF 转 Excel</p>
        </li>
        <li class="rights-item">
          <img src="../../assets/icon/rights/3.png"
               draggable="false"
               class="rights-item-logo"
               alt="">
          <p class="rights-item-des">PDF 转 PPT</p>
        </li>
        <li class="rights-item">
          <img src="../../assets/icon/rights/4.png"
               draggable="false"
               class="rights-item-logo"
               alt="">
          <p class="rights-item-des">PDF 转 图片</p>
        </li>
        <li class="rights-item">
          <img src="../../assets/icon/rights/5.png"
               draggable="false"
               class="rights-item-logo"
               alt="">
          <p class="rights-item-des">PDF 转 TXT</p>
        </li>
        <li class="rights-item">
          <img src="../../assets/icon/rights/6.png"
               draggable="false"
               class="rights-item-logo"
               alt="">
          <p class="rights-item-des">Word 转 PDF</p>
        </li>
        <li class="rights-item">
          <img src="../../assets/icon/rights/7.png"
               draggable="false"
               class="rights-item-logo"
               alt="">
          <p class="rights-item-des">Excel 转 PDF</p>
        </li>
        <li class="rights-item">
          <img src="../../assets/icon/rights/8.png"
               draggable="false"
               class="rights-item-logo"
               alt="">
          <p class="rights-item-des">PPT 转 PDF</p>
        </li>
        <li class="rights-item">
          <img src="../../assets/icon/rights/9.png"
               draggable="false"
               class="rights-item-logo"
               alt="">
          <p class="rights-item-des">图片 转 PDF</p>
        </li>
        <li class="rights-item">
          <img src="../../assets/icon/rights/10.png"
               draggable="false"
               class="rights-item-logo"
               alt="">
          <p class="rights-item-des">CAD 转 PDF</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { isLiebao } from '@/utils'

export default {
  name: 'Rights',
  data () {
    return {
      isLiebao: isLiebao,
    }
  }
}
</script>

<style lang="less" scoped>
.rights {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  &-dialog {
    width: 100%;
    height: 100%;
    background: linear-gradient(315deg, #FF7700 0%, #FA6400 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  &-logo {
    height: 273px;
    display: block;
    margin: 10px auto 6px auto;
  }

  &-title {
    font-size: 44px;
    font-weight: normal;
    color: #FFFFFF;
    letter-spacing: 4px;
  }

  &-subtitle {
    font-size: 16px;
    font-weight: normal;
    color: #FFFFFF;
    letter-spacing: 2px;
    margin-top: 15px;
  }

  &-download {
    display: block;
    background: #FFFFFF;
    border-radius: 22px;
    padding: 10px 50px;
    margin: 24px 0 64px 0;
    font-size: 20px;
    font-weight: bold;
    color: #FD7000;

    &:hover {
      background: #FFF6D6;
    }
  }

  &-wrapper {
    display: flex;
    width: 836px;
    flex-wrap: wrap;
    justify-content: center;
  }

  &-item {
    width: 150px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 26px 0 20px 0;
    background: #FFFFFF;
    border-radius: 4px;
    margin-bottom: 12px;
    margin-right: 12px;
    box-sizing: border-box;

    &-logo {
      height: 70px;
      width: 70px;
    }

    &-des {
      font-size: 14px;
      color: #3C3E40;
      margin-top: 15px;
    }
  }
}
</style>
